import { TypePolicies } from '@apollo/client'

export const inboxTasksTypePolicies: TypePolicies = {
  TasksCategoryCount: {
    keyFields: false,
  },
}
